import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch, generateToken } from "../store";
import styled from "styled-components";
import { CustomCloseButton } from "../components/ToasterCloseButton";
import { toast } from "react-toastify";

const GenerateTokenPage = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [days, setDays] = useState("7");
    const [tag, setTag] = useState("notary");
    const [generatedToken, setGeneratedToken] = useState("");
    const [isGenerating, setIsGenerating] = useState(false);

    const handleGenerate = async () => {
        try {           
            setGeneratedToken("");
            setIsGenerating(true);
            const token = await dispatch(generateToken({ days: Number(days), tag })).unwrap();
            setGeneratedToken(token);
        } catch (err: any) {
          console.log("error in generating passkey", err)
            toast.error(err || "Token generation failed.", {
                autoClose: 3000,
                closeButton: <CustomCloseButton />,
                closeOnClick: false,
                icon: () => null,
            });
        } finally {
            setIsGenerating(false);
        }
    };

    return (
        <Wrapper>
            <Header>Generate Token</Header>
            <InputWrapper>
                <Label>Number of days</Label>
                <Input value={days} onChange={(e) => setDays(e.target.value)} />
            </InputWrapper>
            <InputWrapper>
                <Label>Tag</Label>
                <Input value={tag} onChange={(e) => setTag(e.target.value)} />
            </InputWrapper>
            <GenerateButton onClick={handleGenerate}>{isGenerating ? <LoadingSpinner /> : "Generate"}</GenerateButton>

            {generatedToken && (
                <Result>
                    Token: <span>{generatedToken}</span>
                </Result>
            )}
        </Wrapper>
    );
};

export default GenerateTokenPage;

const Wrapper = styled.div`
  width: 100%;
  padding: 2rem;
  border-radius: 8px;
  background: #fff;
`;

const Header = styled.h2`
  margin-bottom: 1.5rem;
`;

const InputWrapper = styled.div`
  margin-bottom: 1.2rem;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
`;

const Input = styled.input`
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  min-width: 200px;
  width: 100%;
`;

const GenerateButton = styled.button`
  background: #007bff;
  display: flex;
  justify-content: center;
  color: white;
  padding: 10px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  min-width: 100px;
`;

const Result = styled.p`
  margin-top: 2rem;
  font-size: 1rem;
  word-break: break-all;
  color: #333;
`;



const LoadingSpinner = styled.div`
  border: 4.18px solid rgba(0, 0, 0, 0.1); /* Reduced by 5% */
  border-top: 2.09px solid white; /* Reduced by 5% */
  width: 11.4px; /* Reduced by 5% */
  height: 11.4px; /* Reduced by 5% */
  border-radius: 50%; /* Ensures the element is a perfect circle */
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
